// extracted by mini-css-extract-plugin
export const list = "contact-link-list-module--list--3JLEr";
export const iconLink = "contact-link-list-module--iconLink--3D0K1";